var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('Header',{attrs:{"title":"Nové odběrné místo"},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_c('BackLinkButton',{attrs:{"to":{name: 'supply_point_list'}}})]},proxy:true}])}),_c('SupplyPointForm',{attrs:{"isProcessing":_vm.isProcessing},on:{"submitted":_vm.onSubmitted}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }